import { useMemo } from "react";
import { useLocale } from "react-aria";
import { NumberFormatter } from "@internationalized/number";
import { SerializeFrom } from "@remix-run/node";

import { Section } from "./Section";

import { FieldEntry } from "~/components/Form/Form";
import { Text } from "~/components/Text";
import type { AppointmentDetails } from "~/utils/appointment.utils.server";

interface QuestionSectionProps {
  questions: SerializeFrom<FieldEntry>[];
  answers: AppointmentDetails["answers"];
}

export function QuestionSection({ answers, questions }: QuestionSectionProps) {
  const { locale } = useLocale();

  let formatter = useMemo(() => new NumberFormatter(locale), [locale]);

  const answerMap = answers.reduce<Record<string, string>>((acc, data) => {
    const { answer, questionId } = data;

    const value =
      typeof answer.displayValue === "number"
        ? formatter.format(answer.displayValue)
        : answer.displayValue;

    acc[questionId] = value;

    return acc;
  }, {});

  return (
    <Section data-variant="QuestionSection" title={<Text i18nKey="Confirmation.questions" />}>
      {(questions as any as FieldEntry[]).map((entry) => {
        if (Array.isArray(entry.data)) {
          return null;
        }

        return (
          <Section.Item key={entry.id} title={entry.data.label}>
            {answerMap[entry.id] ?? <Text i18nKey="steps.Questions.no_answer" />}
          </Section.Item>
        );
      })}
    </Section>
  );
}
